import FIELD_NAMES from '@/forms/constants/field-names';
import getValueByFieldName from '@/forms/helpers/get-value-by-field-name';
import store from '@/store';
import dateToAPI from '@/forms/helpers/convert-to-date';
import STEP_NAMES from '@/forms/constants/step-names';
const utmDate = function(soure) {
    if (soure !== 'undefined') {
        return soure;
    } else {
        return "";
    }
}

let dateOfBirth = dateToAPI(localStorage.getItem('dob'));
var path = window.location.href;
// let _store = $store;
// if (!_store.state) {
//   _store = store;
// }

const { state: { creditScoreCalculationSatus, appianIncomeInfo, formData: { values } } } = store;
var status;
if (creditScoreCalculationSatus) {
    status = creditScoreCalculationSatus;
}
if (appianIncomeInfo) {
    status = appianIncomeInfo;
}

const payloadMap = {
    [FIELD_NAMES.firstName]: 'first-name',
    [FIELD_NAMES.lastName]: 'last-name',
    [FIELD_NAMES.email]: 'email-address',
    [FIELD_NAMES.phoneNumber]: 'mobile-number',
    [FIELD_NAMES.birthDate]: 'dob',
    [FIELD_NAMES.maritalStatus]: 'marital-status',
    [FIELD_NAMES.fixedIncome]: 'fixed-monthly-income',
    [FIELD_NAMES.mediumOfReceive]: 'mode-of-salary-received',
    [FIELD_NAMES.variableIncome]: 'other-income',
    [FIELD_NAMES.emiratesID]: 'emirates-id-num',
    [FIELD_NAMES.employmentType]: 'employment-type',
    //[FIELD_NAMES.bankAccount]: 'primary-bank-account',
    [FIELD_NAMES.livingTime]: 'length-in-uae',
    [FIELD_NAMES.residenceType]: 'live-in',
    [FIELD_NAMES.areaOfWork]: 'live-emirate',
    [FIELD_NAMES.nationality]: 'nationality',
    [FIELD_NAMES.gender]: 'gender',
    [FIELD_NAMES.consentPoliticalOption]: 'pep',
    [FIELD_NAMES.expiryDate]: 'eid-expiry-date',
    [FIELD_NAMES.passportNumber]: 'passport-number',
    [FIELD_NAMES.passportExpiryDate]: 'passport-expiry',
    [FIELD_NAMES.educationalLevel]: 'education-level',
    [FIELD_NAMES.paymentHoliday]: 'payment-holiday',

};

const companyDetailsMapSalaried = {
    [FIELD_NAMES.companyName]: 'company',
    [FIELD_NAMES.unlistedCompanyName]: 'unlisted-company-name',
    [FIELD_NAMES.designation]: 'designation',
    [FIELD_NAMES.companyAge]: 'length',
    [FIELD_NAMES.industry]: 'industry',
    [FIELD_NAMES.industryTypeEmplyoed]: 'company-category',
    [FIELD_NAMES.emirate]: 'emirate',
    [FIELD_NAMES.workEmail]: 'email',
    [FIELD_NAMES.workAmount]: 'length',

};

const companyDetailsMapSelfEmployed = {
    [FIELD_NAMES.companyNameSelfEmployed]: 'company',
    [FIELD_NAMES.designation]: 'designation',
    [FIELD_NAMES.companyAge]: 'length',
    [FIELD_NAMES.industry]: 'industry',
    [FIELD_NAMES.industryTypeSelfEmplyoed]: 'company-category',
    [FIELD_NAMES.emirate]: 'emirate',
    [FIELD_NAMES.workEmail]: 'email',
    [FIELD_NAMES.workAmount]: 'length',

};

const appointmentMap = {
    [FIELD_NAMES.appointmentDate]: 'date',
    [FIELD_NAMES.appointmentTime]: 'timeframe',
}

const appointmentAddressMap = {
    [FIELD_NAMES.addressLine1]: 'address1',
    [FIELD_NAMES.addressLine2]: 'address2',
    [FIELD_NAMES.nearestLandmark]: 'landmark',
    [FIELD_NAMES.residentialEmirate]: 'emirate',
    [FIELD_NAMES.homeCountryCountry]: 'country',
    [FIELD_NAMES.poBox]: 'postcode',
    [FIELD_NAMES.primaryAddress]: 'primaryAddress',
    [FIELD_NAMES.primaryAddress]: 'local-refernce-name',
    [FIELD_NAMES.primaryAddress]: 'primaryAddress',
}

//Residence Address
const residentAddressMap = {
    [FIELD_NAMES.addressLine1Home]: 'address1',
    [FIELD_NAMES.addressLine2Home]: 'address2',
    [FIELD_NAMES.poBoxHome]: 'postcode',
    [FIELD_NAMES.residentialEmirateHome]: 'emirate',
    [FIELD_NAMES.homeCountryCountryHome]: 'country',
}
var homeCountryAddressMap
    //Home Country Address


homeCountryAddressMap = {
    [FIELD_NAMES.fullNameHomecountry]: 'name',
    [FIELD_NAMES.homeCountryPhoneCountryCode]: 'phone-prefix',
    [FIELD_NAMES.homeCountryPhone]: 'phone',
    [FIELD_NAMES.homeCountryAddress]: 'address1',
    [FIELD_NAMES.homeCountryAdditionalAddress]: 'address2',
    [FIELD_NAMES.homeCountryCountry]: 'country',
    [FIELD_NAMES.homeCountryPoscode]: 'postcode',
    [FIELD_NAMES.homeCountryNumber]: 'number',

}

//BankInfo
const bankInfoMap = {
        [FIELD_NAMES.emiratesNBD]: 'name',
        [FIELD_NAMES.IBANNumber]: 'iban',
        [FIELD_NAMES.bankAccountTitle]: 'nickname',
    }
    //UAE Reference

const uaeReferenceMap = {
        [FIELD_NAMES.fullNameRefernce]: 'name',
        [FIELD_NAMES.referencePhoneNumber]: 'number',

    }
    //Home Reference
const homeReferenceMap = {
        [FIELD_NAMES.referencesHomeCountryFullName]: 'name',
        [FIELD_NAMES.referencesHomeCountryPhone]: 'number',

    }
    //Insurance
    // const insurance={
    //   [FIELD_NAMES.insuranceType]:'type-of-insurance',
    //   [FIELD_NAMES.firstName]: 'first-name',
    //   [FIELD_NAMES.lastName]: 'last-name',
    //   [FIELD_NAMES.email]: 'email-address',
    //   [FIELD_NAMES.phoneNumber]: 'mobile-number',
    //   [FIELD_NAMES.emiratesID]: 'emirates-id-num',
    //   [FIELD_NAMES.consent]:'consent',
    // }

const getPayload = () => {

    const { state } = store;

    const {
        appId,
        cifnumber,
        monthlyInstalment,
        source,
        medium,
        campaign,
        content,
        productId,
        productType,
        productTypeFromUrl,
        use,
        howMuch,
        instalment,
        spending,
        salaryReceive,
        rewardType,
        cashBackPoint,
        tenToTwentyFive,
        moreThanTwentyFive,
        employeeCodes,
        other,
        employmentType,
        cardType,
        loanType,
        bankName,
        promoCodeStatus,
        institutions,
        appianPersonalInfo,
        appianIdentityInfo,
        appianEmpInfo,
        appianIncomeInfo,
        appianCardType,
        stpPreScreenedAmount,
        accuityResponse,
        applicationStatus,
        deemDoubleSecureLoanProtect,
        deemGuardCreditLife,
        formData: { values }
    } = state;
    const consentFlag = getValueByFieldName(values, FIELD_NAMES.consent);
    const employeeCode = getValueByFieldName(values, FIELD_NAMES.employeeCode);
    const salesManager = getValueByFieldName(values, FIELD_NAMES.salesManager);
    const channel = getValueByFieldName(values, FIELD_NAMES.channel);
    const productInterested = getValueByFieldName(values, FIELD_NAMES.productInterested)
    const product = getValueByFieldName(values, FIELD_NAMES.product);
    var instalmentAsked = getValueByFieldName(values, FIELD_NAMES.instalments);
    var loanAmount = getValueByFieldName(values, FIELD_NAMES.howmuch);
    let iban;
    if (getValueByFieldName(values, FIELD_NAMES.IBAN)) {
        iban = 'AE' + getValueByFieldName(values, FIELD_NAMES.IBAN);
    } else {
        iban = ""
    }
    // let ibanNumber = typeof iban !== 'undefined' ? 'AE' + getValueByFieldName(values, FIELD_NAMES.IBAN) : "";
    let nameOnCard = getValueByFieldName(values, FIELD_NAMES.nameOnCard);
    let desiredCreditLimit
    if (getValueByFieldName(values, FIELD_NAMES.feedback)) {
        desiredCreditLimit = 0;
    } else {
        desiredCreditLimit = getValueByFieldName(values, FIELD_NAMES.creditCardLimit);
    }

    let cyclePaymentDate = getValueByFieldName(values, FIELD_NAMES.instalmentDueDate);
    let reasonOfReject = getValueByFieldName(values, FIELD_NAMES.feedback)
    var bureauConsent = '';
    var promoCode = "";
    var utm_Source = source;
    var utm_Content = content;
    var utm_Medium = medium
    var utm_Campaign = campaign
        //   let bankName
        //  if(institutions ) 
        //  {
        //  var bankName2=institutions.find(obj => {
        //     return obj.id === getValueByFieldName(FIELD_NAMES.bankAccount,values);
        //   });
        //   if(bankName2)
        //   {
        //   bankName=bankName2.name;
        //   }
        // }
        //   else
        //   {
        //     bankName="";
        //   }

    if (promoCodeStatus && promoCodeStatus === 'SUCCESS') {
        promoCode = getValueByFieldName(values, FIELD_NAMES.promoCodeInput);
    } else {
        promoCode = "";
    }
    if (consentFlag) {
        bureauConsent = 'Y'
    } else {
        bureauConsent = 'N'
    }
    var porducts = '';
    if (cardType) {
        porducts = cardType
    } else {
        porducts = loanType
    }
    var accuityPayload;
    if (accuityResponse) {
        accuityPayload = {
            "case-status": accuityResponse['CaseStatus'],
            "screening-status": accuityResponse['ScreeningStatus'],
            "total-CWL": accuityResponse['TotalCWL'],
            "total-GWL": accuityResponse['TotalGWL'],
            "total-PEPEDD": accuityResponse['TotalPEPEDD'],
            "total-private": accuityResponse['TotalPrivate']
        }
    }
    var appianPayload;
    appianPayload = {
        "personal-info": typeof appianPersonalInfo !== 'undefined' ? {
            "status": appianPersonalInfo
        } : {},
        "identity-info": typeof appianIdentityInfo !== 'undefined' ? {
            "status": appianIdentityInfo
        } : {},
        "emp-info": typeof appianEmpInfo !== 'undefined' ? {
            "status": appianEmpInfo
        } : {},
        "income-info": typeof appianIncomeInfo !== 'undefined' ? {
            "status": appianIncomeInfo,
            "card-type": appianCardType,
            "card-limit": stpPreScreenedAmount
        } : {},
    }
    var nbcLoanPayload = [];

    if (productTypeFromUrl == 'card') {
        if (rewardType === 'Cash Up for cashback' || rewardType === 'Miles Up for travel rewards') {
            if (cashBackPoint === 'Less than AED 10,000') {
                nbcLoanPayload = [

                    {
                        "question": 'What kind of rewards would you like?',
                        "answer": typeof rewardType !== 'undefined' ? rewardType : ""
                    },
                    {
                        "question": 'What is your fixed monthly income?',
                        "answer": typeof cashBackPoint !== 'undefined' ? cashBackPoint : ""
                    }
                ]
            } else if (cashBackPoint === 'AED 10,000 - AED 25,000') {
                nbcLoanPayload = [

                    {
                        "question": 'What kind of rewards would you like?',
                        "answer": typeof rewardType !== 'undefined' ? rewardType : ""
                    },
                    {
                        "question": 'What is your fixed monthly income?',
                        "answer": typeof cashBackPoint !== 'undefined' ? cashBackPoint : ""

                    },
                    {
                        "question": 'What are you going to use it for?',
                        "answer": typeof tenToTwentyFive !== 'undefined' ? tenToTwentyFive : ""
                    }
                ]
            } else if (cashBackPoint === 'More than AED 25,000') {
                nbcLoanPayload = [

                    {
                        "question": 'What kind of rewards fit you?',
                        "answer": typeof rewardType !== 'undefined' ? rewardType : ""
                    },
                    {
                        "question": 'What is your fixed monthly income?',
                        "answer": typeof cashBackPoint !== 'undefined' ? cashBackPoint : ""
                    },
                    {
                        "question": 'What are you going to use it for the most?',
                        "answer": typeof moreThanTwentyFive !== 'undefined' ? moreThanTwentyFive : ""
                    }
                ]
            }
        }

    }
    //////
    else if (productTypeFromUrl === 'loan') {
        if (use === 'Other') {

            nbcLoanPayload = [{
                    "question": "What are you going to use the loan for?",
                    "answer": typeof use !== 'undefined' ? other : ""
                },
                {
                    "question": "How much do you need to borrow?",
                    "answer": typeof howMuch !== 'undefined' ? '' + howMuch + '' : ""
                },
                {
                    "question": "In how many instalments would you like to repay?",
                    "answer": typeof instalment !== 'undefined' ? instalment : ""
                },

            ];
        } else {
            nbcLoanPayload = [{
                    "question": "What are you going to use the loan for?",
                    "answer": typeof use !== 'undefined' ? use : ""
                },
                {
                    "question": "How much do you need to borrow?",
                    "answer": typeof howMuch !== 'undefined' ? '' + howMuch + '' : ""
                },
                {
                    "question": "In how many instalments would you like to repay?",
                    "answer": typeof instalment !== 'undefined' ? '' + instalment + '' : ""
                },

            ];
        }
    } else if (productTypeFromUrl === 'insurance') {
        nbcLoanPayload = [{
                "question": "",
                "answer": ""
            },
            {
                "question": "",
                "answer": ""
            },
            {
                "question": "",
                "answer": ""
            },
        ]
    }
    if (employeeCodes || employeeCode) {
        nbcLoanPayload = [{
                "question": "What are you going to use the loan for?",
                "answer": typeof use !== 'undefined' ? use : ""
            },
            {
                "question": "How much do you need to borrow?",
                "answer": typeof howMuch !== 'undefined' ? '' + howMuch + '' : ""
            },
            {
                "question": "In how many instalments would you like to repay?",
                "answer": typeof instalment !== 'undefined' ? '' + instalment + '' : ""
            },

        ];
        utm_Source = channel;
        utm_Medium = employeeCode;
        utm_Campaign = salesManager;
        utm_Content = 'FS';
    }
    if (path.includes('onboarding-digital') && productType === 'Personal_Loan') {
        nbcLoanPayload = [{
                "question": "What are you going to use the loan for?",
                "answer": typeof use !== 'undefined' ? use : ""
            },
            {
                "question": "How much do you need to borrow?",
                "answer": typeof loanAmount !== 'undefined' ? '' + loanAmount + '' : ""
            },
            {
                "question": "In how many instalments would you like to repay?",
                "answer": typeof instalmentAsked !== 'undefined' ? '' + instalmentAsked + '' : ""
            },

        ];
        // toSend['credit-life-plus'] = typeof deemGuardCreditLife !== 'undefined' ? deemGuardCreditLife : '';
        // toSend['loan-protect'] = typeof deemDoubleSecureLoanProtect !== 'undefined' ? deemDoubleSecureLoanProtect : '';
    }
    // if (path.includes('onboarding-digital') && productType === 'Credit Card') {
    //     toSend['deem-guard'] = typeof deemGuardCreditLife !== 'undefined' ? '' + deemGuardCreditLife + '' : '';
    //     toSend['double-secure'] = typeof deemDoubleSecureLoanProtect !== 'undefined' ? '' + deemDoubleSecureLoanProtect + '' : ''
    // }
    //     var supplementaryCard={};
    // var length=store.state.formData.supplementaryCards.length;
    // for(var obj in store.state.formData.supplementaryCards)
    // {

    // }

    //var path = window.location.href;
    var balanceTransfers = [];
    var productSelected;
    var autoProduct;

    store.state.formData.balanceTransfers.forEach(element => {
        var balanceTransfer = {
            bureauScore: '',
            prescreenLimit: '',
            fixedIncome: '',
            bankName: '',
            creditCardNumber: '',
            cardLimit: '',
            btRequestAmount: '',
            btType: '',
            btEligibleAmount: ''

        }
        balanceTransfer.bureauScore = store.state.bureauScore;
        balanceTransfer.prescreenLimit = '' + store.state.preScreendedAmount + '';
        balanceTransfer.fixedIncome = '' + store.state.incomeFixed + '';
        balanceTransfer.bankName = element.bankName;
        balanceTransfer.creditCardNumber = element.creditCardNumber;
        balanceTransfer.cardLimit = element.cardLimit;
        balanceTransfer.btRequestAmount = element.btRequestAmount;
        balanceTransfer.btType = element.btType;
        balanceTransfer.btEligibleAmount = '' + store.state.btTrnsferLimit + '';
        balanceTransfers.push(balanceTransfer);
    });


    const toSend = Object.keys(values)
        .filter(key => key in payloadMap && values[key])
        .reduce((obj, key) => {
            const mappedKey = payloadMap[key];
            obj[mappedKey] = getValueByFieldName(values, key);
            return obj;
        }, {});
    //company
    const toSendCompanySalaried = Object.keys(values)
        .filter(key => key in companyDetailsMapSalaried && values[key])
        .reduce((obj, key) => {
            const mappedKey = companyDetailsMapSalaried[key];
            if (mappedKey === 'company') {
                var isObject = getValueByFieldName(values, key)
                obj[mappedKey] = typeof isObject === "object" ? "Other" : getValueByFieldName(values, key);

            } else {
                obj[mappedKey] = getValueByFieldName(values, key);
            }

            return obj;
        }, {});
    const toSendCompanySelf = Object.keys(values)
        .filter(key => key in companyDetailsMapSelfEmployed && values[key])
        .reduce((obj, key) => {
            const mappedKey = companyDetailsMapSelfEmployed[key];
            obj[mappedKey] = getValueByFieldName(values, key);

            return obj;
        }, {});
    //appointment
    const toSendAppointment = Object.keys(values)
        .filter(key => key in appointmentMap && values[key])
        .reduce((obj, key) => {
            const mappedKey = appointmentMap[key];
            obj[mappedKey] = getValueByFieldName(values, key);

            return obj;
        }, {});
    //appointment address
    const toSendAppointmentAddress = Object.keys(values)
        .filter(key => key in appointmentAddressMap && values[key])
        .reduce((obj, key) => {
            const mappedKey = appointmentAddressMap[key];
            obj[mappedKey] = getValueByFieldName(values, key);

            return obj;
        }, {});
    //residence address
    const toSendResidenceAddress = Object.keys(values)
        .filter(key => key in residentAddressMap && values[key])
        .reduce((obj, key) => {
            const mappedKey = residentAddressMap[key];
            obj[mappedKey] = getValueByFieldName(values, key);

            return obj;
        }, {});
    //home-country address
    const toSendHomeCountryAddress = Object.keys(values)
        .filter(key => key in homeCountryAddressMap && values[key])
        .reduce((obj, key) => {
            const mappedKey = homeCountryAddressMap[key];
            obj[mappedKey] = getValueByFieldName(values, key);

            return obj;
        }, {});
    //Bank Details
    const toSendBankDetails = Object.keys(values)
        .filter(key => key in bankInfoMap && values[key])
        .reduce((obj, key) => {
            const mappedKey = bankInfoMap[key];
            obj[mappedKey] = getValueByFieldName(values, key);

            return obj;
        }, {});
    //UAE Reference
    const toSendUaeRefDetails = Object.keys(values)
        .filter(key => key in uaeReferenceMap && values[key])
        .reduce((obj, key) => {
            const mappedKey = uaeReferenceMap[key];
            obj[mappedKey] = getValueByFieldName(values, key);

            return obj;
        }, {});
    //INDIA Reference
    const toSendHomeRefDetails = Object.keys(values)
        .filter(key => key in homeReferenceMap && values[key])
        .reduce((obj, key) => {
            const mappedKey = homeReferenceMap[key];
            obj[mappedKey] = getValueByFieldName(values, key);

            return obj;
        }, {});
    //
    if (appId) {
        toSend['app-id'] = appId;
    }
    toSend['last-screen-visited'] = JSON.stringify(state.formData);
    toSend['current-step'] = state.formData.currentStepName;
    if (productInterested) {
        toSend['product-name'] = productInterested;
    } else if (product === 'Top Up') {
        toSend['product-name'] = 'TOPUP';
        productSelected = 'TOPUP';
        autoProduct = 'TOPUP'
    } else if (product === 'New Car' || product === 'Used Car') {
        toSend['product-name'] = 'Auto Loan';
        productSelected = 'Auto Loan';
        autoProduct = product
    } else if (path.includes('onboarding-digital')) {
        if (state.formData.currentStepName === STEP_NAMES.creditCard) {
            autoProduct = state.cardType;
            toSend['product-name'] = 'Credit Card'
        } else if (state.formData.currentStepName === STEP_NAMES.loan) {
            toSend['product-name'] = 'Personal_Loan'
        }

    } else {

        toSend['product-name'] = typeof productType !== 'undefined' ? productType : "";
    }

    toSend['consent-flag'] = bureauConsent;
    toSend['promo-code'] = promoCode;
    toSend['iban'] = iban;
    toSend['accuity'] = typeof accuityPayload !== 'undefined' ? accuityPayload : null;
    toSend['appian'] = typeof appianPayload !== 'undefined' ? appianPayload : null;
    if (productTypeFromUrl === 'loan') {
        toSend['nbc-loan'] = typeof nbcLoanPayload !== 'undefined' ? nbcLoanPayload : null;
    }
    if (productTypeFromUrl === 'card') {
        toSend['nbc-loan'] = typeof nbcLoanPayload !== 'undefined' ? nbcLoanPayload : null;


    }
    if (employeeCodes || employeeCode) {
        toSend['nbc-loan'] = typeof nbcLoanPayload !== 'undefined' ? nbcLoanPayload : null;
    }
    if (productTypeFromUrl === 'insurance') {
        toSend['nbc-loan'] = typeof nbcLoanPayload !== 'undefined' ? nbcLoanPayload : null;
    }
    if (path.includes('onboarding-digital')) {
        toSend['nbc-loan'] = typeof nbcLoanPayload !== 'undefined' ? nbcLoanPayload : null;
    }
    if (path.includes('card') || path.includes('lead-page/start') || path.includes('nbc/stp-card') || path.includes('nbc/card') ||
        path.includes('stp/sales') || path.includes('auto/sales') || path.includes('stp-card') || path.includes('credit-card') || path.includes('eid/reader') || path.includes('stp-loan') || path.includes('/loan') || path.includes('stp-topup') ||
        path.includes('onboarding-digital')) {
        toSend['nbc-loan'] = typeof nbcLoanPayload !== 'undefined' ? nbcLoanPayload : null;
        toSend['supplementary-card'] = typeof JSON.parse(JSON.stringify(store.state.formData.supplementaryCards)) !== 'undefined' ? JSON.parse(JSON.stringify(store.state.formData.supplementaryCards)) : [];
        // toSend['balance-transfer'] = JSON.parse(JSON.stringify(store.state.formData.balanceTransfers))
        toSend['balance-transfer'] = JSON.parse(JSON.stringify(balanceTransfers))
            // toSend['balance-transfer'] = [];
    }
    if (productInterested) {
        nbcLoanPayload = [{
            "question": null,
            "answer": null
        }];
        toSend['nbc-loan'] = nbcLoanPayload;
        toSend['balance-transfer'] = JSON.parse(JSON.stringify(balanceTransfers))
        toSend['supplementary-card'] = typeof JSON.parse(JSON.stringify(store.state.formData.supplementaryCards)) !== 'undefined' ? JSON.parse(JSON.stringify(store.state.formData.supplementaryCards)) : [];

    }
    var toSendCompany = {};
    if (productType === 'Credit Card') {
        console.log('deemGuard=' + productType)
        toSend['deem-guard'] = deemGuardCreditLife;
        toSend['double-secure'] = deemDoubleSecureLoanProtect
    }
    if (productType === 'Personal_Loan') {
        toSend['credit-life-plus'] = deemGuardCreditLife;
        toSend['loan-protect'] = deemDoubleSecureLoanProtect
    }
    if (employmentType === 'Salaried' || productInterested) {
        toSendCompany = toSendCompanySalaried
    } else {
        toSendCompany = toSendCompanySelf
    }

    return {
        'app-detail': {
            "cif-number": cifnumber,
            ...toSend,
            // "dob":dateOfBirth,
            "bureau-score": null,

            "bank-name": bankName,
            "app-status": null,
            "application-status": applicationStatus ? applicationStatus : "",
            "card": {
                "name-on-card": typeof nameOnCard !== 'undefined' ? nameOnCard : "",
                "desired-credit-limit": typeof desiredCreditLimit !== 'undefined' ? desiredCreditLimit : 0,
                "cycle-date": typeof cyclePaymentDate !== 'undefined' ? cyclePaymentDate : "",
                "reason-of-reject": typeof reasonOfReject !== 'undefined' ? reasonOfReject : "",
            },
            'appointment': {
                ...toSendAppointment,
                'address': {
                    ...toSendAppointmentAddress,
                    "number": null,
                    "type": null,
                    "branch": null,
                },
            },
            'offer-rejected': {
                "reason": ''
            },
            'residence': {
                'address': {
                    "type": 'HOME',
                    ...toSendResidenceAddress,
                    "number": null,
                }
            },
            'work': {
                ...toSendCompany,
                "emirate-detail": null,
                "address": {
                    "address1": null,
                    "address2": null,
                    "number": null,
                    "postcode": null
                }
            },
            'home-country': {
                "address": {
                    ...toSendHomeCountryAddress
                }
            },
            "supervisor": {
                "name": null,
                "address": {
                    "address1": null,
                    "address2": null,
                    "number": null,
                    "postcode": null,
                    "country": null,
                    "phone": null
                }
            },
            'bank': {
                ...toSendBankDetails,
                'monthly-instlment': monthlyInstalment


            },
            "reference": {
                "uae": {
                    ...toSendUaeRefDetails
                },
                "home": {
                    ...toSendHomeRefDetails
                },
            },

            "utm": {
                "source": typeof utm_Source !== 'undefined' ? utm_Source : "DIRECT",
                "medium": typeof utm_Medium !== 'undefined' ? utm_Medium : "",
                "campaign": typeof utm_Campaign !== 'undefined' ? utm_Campaign : "",
                "content": typeof utm_Content !== 'undefined' ? utm_Content : "",
                "product-id": typeof productSelected !== 'undefined' ? productSelected : typeof productType !== 'undefined' ? productType : "",
                "card-type": typeof autoProduct !== 'undefined' ? autoProduct : typeof porducts !== 'undefined' ? porducts : "",
                //"product-id": typeof productType !== 'undefined' ? productType : "",
                //"card-type": typeof porducts !== 'undefined' ? porducts : "",
            },

        },

    };
};

export default getPayload;